// Central author / editorial team data for E-E-A-T signals.
// Used by Seo.jsx (Article > author Person schema) + ArticlePage byline UI.
// To attribute a blog to a specific author, set `blog.author = "martijn"`
// (slug matching keys below). Default falls back to "equisight_editorial".

export const AUTHORS = {
  martijn: {
    slug: "martijn",
    name: "Martijn Wirken",
    jobTitle: "Founder & Product Lead",
    affiliation: "SaFleu Equestrian Centre BV",
    bio:
      "Martijn is oprichter van EquiSight. Met een achtergrond in datagedreven " +
      "sportprestatie en jarenlange paardensport-ervaring bouwt hij gereedschap " +
      "dat ruiters, trainers en stallen helpt om elke beslissing beter te onderbouwen.",
    image: "https://equisight.nl/assets/authors/martijn.webp",
    sameAs: [
      "https://www.linkedin.com/in/martijnwirken/",
      "https://www.instagram.com/equi.sight/",
    ],
    knowsAbout: [
      "Paardentraining",
      "Sport analytics",
      "Product design",
      "KNHS wedstrijdprotocollen",
    ],
  },
  equisight_editorial: {
    slug: "equisight_editorial",
    name: "EquiSight Editorial",
    jobTitle: "Redactie",
    affiliation: "EquiSight · SaFleu Equestrian Centre BV",
    bio:
      "Het EquiSight-redactieteam combineert dierenartsen, hoefsmeden, FEI-trainers " +
      "en gediplomeerde voederexperts. Elk artikel wordt gecheckt op feitelijkheid " +
      "en bijgewerkt zodra richtlijnen of literatuur veranderen.",
    image: "https://equisight.nl/assets/authors/editorial.webp",
    sameAs: ["https://www.instagram.com/equi.sight/"],
    knowsAbout: [
      "Paardengezondheid",
      "Paardenvoeding",
      "Hoefverzorging",
      "Vaccinaties paard",
      "Wedstrijdanalyse",
    ],
  },
};

export const DEFAULT_AUTHOR_SLUG = "equisight_editorial";

/** Resolve a blog's author object — falls back to editorial. */
export function getAuthor(slug) {
  if (slug && AUTHORS[slug]) return AUTHORS[slug];
  return AUTHORS[DEFAULT_AUTHOR_SLUG];
}

/** Build a Schema.org Person node for JSON-LD. */
export function authorSchema(slug, siteUrl = "https://equisight.nl") {
  const a = getAuthor(slug);
  return {
    "@type": "Person",
    "@id": `${siteUrl}/#author-${a.slug}`,
    name: a.name,
    jobTitle: a.jobTitle,
    description: a.bio,
    image: a.image,
    url: `${siteUrl}/over-ons#${a.slug}`,
    sameAs: a.sameAs,
    knowsAbout: a.knowsAbout,
    worksFor: {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
    },
  };
}

export default AUTHORS;
